import EventManager from "../../manager/event_manager";
import { RedPointModule, RedPointComponent } from "./component/redpoint_component";
import AppData from './const/app_data';
import ModelData from "./model_data";
import GameUtil from "../../utility/game_util";
import ModuleManager from "../../framework/core/module_manager";
import { Notify } from "../hall/server/notify/proto_notify";
import NotifyServer from "../hall/server/notify/notify_server";
import { GameManager } from "../../manager/game_manager";
import { TaskHelp } from "../hall/module/gametask/task_help";
import { club_utils } from "../club/club_utils";

export interface IRedPointData {
    count?: number;//显示个数
    isHave?: boolean;//是否显示红点
}

export class PlayerPosition {
    positions: Notify.IChangePlayerPosition[] = [];//位置模块
    tag: string = '';
    curPos: string = '';//当前位置
    oldPos: string = '';//旧位置
}

export class NotifyData {

    private static _instance: NotifyData;

    static m_max_count = 10;//存储最新的10条

    protected m_message_queue: any[] = []//所有最新消息

    protected redPointArray: RedPointComponent[] = [];

    protected redPointTag: { [k: string]: IRedPointData } = {};

    protected positions: { [k: string]: PlayerPosition } = {};

    protected oldPosition: PlayerPosition;

    static isBagRedPoint: boolean = false;

    static isVipRedPoint: boolean = false;

    static msgId: number = 0;

    public static get instance(): NotifyData {

        if (!NotifyData._instance) {
            NotifyData._instance = new NotifyData();
            NotifyData._instance.init();
        }
        return NotifyData._instance;
    }

    get messageQueue() {
        return this.m_message_queue;
    }

    private init() {
        this.bindEvent();
        this.registerPositions();
        NotifyServer.instance.registTagCallBack = this.connected.bind(this);
        //NotifyServer.instance.schedule(this.checkRedPoint.bind(this),10,Number.MAX_VALUE)
    }

    //红点检测 每隔 10秒检测:大厅 Notify断开时候
    private checkRedPoint() {
        if (!NotifyServer.instance.netClient.netState) {
            this.req_refresh_redpoint();
        }
    }


    private connected() {
        //AppData.apiLanguage
        //测试用 "zh-CN"   正常用 AppData.apiLanguage
        NotifyServer.instance.registGameTag();

        this.sendPosToServer();
    }    
   

    private bindEvent() {
         EventManager.instance.on('game_event_show',this.resumeTime,this,true)
        EventManager.instance.on('Event_Notify_Data', this.on_msg_coming, this, true)
        EventManager.instance.on('Event_Notify_RedPoint', this.req_refresh_redpoint, this, true)
        EventManager.instance.on('Event_Notify_RedPoint_Change', this.changeRedPointData, this, true)
        EventManager.instance.on('Event_Notify_RedPoint_Refresh', this.refreshAllRedPoint, this, true)
        EventManager.instance.on('Event_Notify_RedPoint_Change_Refresh', this.changeRedPointDataAndRefresh, this, true)
    }
    //------------------------------------位置上报-----------------------

    //登录 notifyServer
    loginNotifyServer() {
        if (!NotifyServer.instance.netClient.netState) {
            NotifyServer.instance.connectServer(GameManager.notifyServer + ModelData.instance.userToken)
        }
    }

    private registerPositions() {
        this.pushPositions('hall', 'hall');//--大厅
        this.pushPositions('game', 'room');//--房间
        this.pushPositions('club','club');//--俱乐部
        this.oldPosition = new PlayerPosition();
    }

    private pushPositions(key: string, tag: string) {
        this.positions[key] = new PlayerPosition();
        this.positions[key].tag = tag;
    }

    changePlayerPos(key: string, isFroce: boolean = false) {
        let data = this.positions[key];
        this.oldPosition.tag = data.tag;
        if (!data) {
            return;
        }


        let GoldFieldID = null
        let gameGoldAccountType = null;
        let roomid = '';
        let clubid = null;
        let gameId = '';

        if (key && key == 'game') {

            gameId = AppData.gameName;
            if (ModelData.instance.tableCommonData) {
                gameGoldAccountType = ModelData.instance.tableCommonData.isClubTable ? 200 : 6
            }
            if (ModelData.instance.roomId) {
                roomid = ModelData.instance.roomId.toString();
            }
            if (ModelData.instance.roomInfo) {
                GoldFieldID = ModelData.instance.roomInfo.GoldFieldID;
            }
        }

        if (key && key == 'club') {
            clubid = club_utils.clubId;
        }

        let msg: Notify.IChangePlayerPosition = {
            gameId: gameId,
            gameName: gameId,
            roomId: roomid,
            position: data.tag,
            gameGoldId: GoldFieldID,
            gameGoldAccountType: gameGoldAccountType,
            clubId:clubid,
        }

        this.oldPosition.positions[0] = msg;

        if (this.isNotifyConnected()) {
            NotifyServer.instance.sendPlayerPosition(msg);
        } else {
            data.positions.push(msg);//缓存
        }
    }

    reset() {
        this.resetPlayerPos();
        this.clearMessage();
        TaskHelp.clear();
        EventManager.instance.dispatch('_clear_message_');
    }

    resetPlayerPos() {
        for (let pos in this.positions) {
            let changePos = this.positions[pos];
            if (changePos) {
                changePos.oldPos = '';
                changePos.positions = [];
            }
        }
        this.oldPosition.positions = [];
    }

    protected isNotifyConnected(): boolean {
        return NotifyServer.instance.netClient.netState
    }

    private sendPosToServer() {

        if (this.isNotifyConnected()) {
            //缓存
            for (let pos in this.positions) {
                let changePos = this.positions[pos];
                if (changePos) {
                    for (let pos of changePos.positions) {
                        NotifyServer.instance.sendPlayerPosition(pos);
                    }
                    changePos.positions = [];
                }
            }

            if (this.oldPosition) { //重连位置
                for (let pos of this.oldPosition.positions) {
                    NotifyServer.instance.sendPlayerPosition(pos);
                }
            }
        }
    }

    resumeTime(isShow:boolean,time1:number){
        if (isShow) {
            TaskHelp.startTime += time1/1000;
        }
    }

    //------------------------------------red point-----------------------

    private req_refresh_redpoint() {
        this.reqRedPointMsg();
    }

    private getPointTag(redmodule: RedPointModule): IRedPointData {
        if (!this.redPointTag[redmodule]) {
            this.redPointTag[redmodule] = {};//邮件
        }
        return this.redPointTag[redmodule];
    }

    registerRedPint(redComp: RedPointComponent) {
        if (redComp && redComp.isExist()) {
            this.redPointArray.push(redComp);
        }
    }

    removeRedPoint(redComp: RedPointComponent) {
        if (redComp && redComp.isExist()) {
            for (let idx = 0; idx < this.redPointArray.length; idx++) {
                let comp = this.redPointArray[idx];
                if (comp && comp.isExist()
                    && comp.isSameModule(redComp)) {
                    this.redPointArray.splice(idx, 1);
                    break;
                }
            }
        }
    }

    reqRedPointMsg(comp?: Function) {
        let self = this;
        //客户端 需要延时一定时间才能请求正确数据
        setTimeout(() => {
            self.getMainRedPoint((data: any) => {
                NotifyData.isVipRedPoint = data.isVipAward
                this.setRedPointCount(RedPointModule.Mail, data.mailCount);
                this.setRedPointCount(RedPointModule.Activity, data.isReceiveDayWelfare || !data.isAppScore || !data.isActivationAward);
                this.setRedPointCount(RedPointModule.Task, data.taskTotalCount);
                this.setRedPointCount(RedPointModule.Task_every, data.everydayCount);
                this.setRedPointCount(RedPointModule.Task_growth, data.growthCount);
                this.setRedPointCount(RedPointModule.Task_time, data.timeCount);
                this.setRedPointCount(RedPointModule.VideoReward, data.advActivityCount);
                this.setRedPointCount(RedPointModule.Bag_Vip, data.isVipAward || NotifyData.isBagRedPoint);
                ModelData.instance.isAppScore = !data.isAppScore
                ModelData.instance.isActivationAward = !data.isActivationAward
                self.refreshAllRedPoint();
                comp && comp(data);
            });
        }, 100)
    }

    private setRedPointCount(redmodule: RedPointModule, cnt: number|boolean) {
        let redpoint = this.getPointTag(redmodule);
        redpoint.isHave = cnt > 0
    }

    refreshOneRedPoint(comp: RedPointComponent) {
        if (comp && comp.isExist()) {
            let data = this.redPointTag[comp.module]
            comp.refreshRedPoint(data);
        }
    }

    //更新所有红点
    refreshAllRedPoint(redPointModule?: RedPointModule) {
        for (let idx = 0; idx < this.redPointArray.length; idx++) {
            let comp = this.redPointArray[idx];
            this.refreshOneRedPoint(comp);
        }
    }

    private getMainRedPoint(success: Function) {
        let requestData: IHttpRequestData = {
            baseUrl: 'user/getMainRedPoint?',
            notShow500ErrorToast: true
        }
        GameUtil.apiHttpGet(requestData, function (retData) {
            success(retData.data)
        })
    }

    //获取背包数据是否显示小红点
    getBagData(){
        let self = this
        let requestData: IHttpRequestData = {
            baseUrl: 'item/getUserItemList?',
            notShow500ErrorToast: true
        }
        GameUtil.apiHttpGet(requestData, function (retData) {
            NotifyData.isBagRedPoint = retData.data.length > 0
            if (retData.data.length == 1){
                if (retData.data[0].itemCode == "Item_Horn" || retData.data[0].itemCode == "LABA_ITEM"){
                    NotifyData.isBagRedPoint = false
                }
            }
            self.setRedPointCount(RedPointModule.Bag_Vip, (NotifyData.isVipRedPoint || NotifyData.isBagRedPoint));
        })
    }

    private changeRedPointData(redPointModule: RedPointModule, count: number) {
        let redpoint = this.getPointTag(redPointModule);
        redpoint.count = count
        redpoint.isHave = count && (count > 0);//是否显示
    }

    private changeRedPointDataAndRefresh(redPointModule: RedPointModule, count: number) {
        this.changeRedPointData(redPointModule, count)
        this.refreshAllRedPoint()
    }


    protected on_msg_coming(msg) {
        if (msg.notifyType == "broadcast") {
            NotifyData.pushMessage(this.m_message_queue, msg);
            NotifyData.cutQueue(this.m_message_queue);
        } else if (msg.notifyType == 'new_mail') {
            this.reqRedPointMsg();
        }
    }

    static removeMessage(msg: any) {
        for (let index = 0; index < NotifyData.instance.messageQueue.length; index++) {
            let _msg = NotifyData.instance.messageQueue[index];
            if (_msg && _msg.id && _msg.id == msg.id) {
                if (_msg.count != undefined
                    && _msg.count <= 0) {
                    NotifyData.instance.messageQueue.splice(index, 1);
                    break;
                }
            }
        }
    }

    //获取消息
    static pushMessage(messagequeue: any[], msg: any, condition?: Function) {
        let canUnshift = false;
        msg.id = NotifyData.msgId++;//每条消息标识
        msg.count = parseInt(JSON.parse(msg.content).showCount)
        if (condition) {
            canUnshift = condition(msg);
        } else {
            canUnshift = true;
        }
        if (canUnshift) {
            messagequeue.unshift(msg);
        }
    }

    static cutQueue(messagequeue: any[]) {
        if (messagequeue.length > NotifyData.m_max_count) {
            messagequeue.splice(NotifyData.m_max_count, messagequeue.length - NotifyData.m_max_count)
        }
    }

    public clearMessage() {
        this.m_message_queue = [];//清空缓存
        NotifyData.isBagRedPoint = false;
        NotifyData.isVipRedPoint = false;
    }


}
